var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('loader',{attrs:{"active":_vm.$apollo.queries.getContentByTitle.loading,"size":"medium","has-overlay":true}},[(_vm.getContentByTitle)?_c('Footer',{attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }